module.exports = "<!DOCTYPE HTML>\r\n\r\n<router-outlet></router-outlet>\t\r\n"


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/main.component.html
// module id = ../../../../../src/app/main/main.component.html
// module chunks = main